import React from 'react';
import { Trans, useTranslation } from "react-i18next";
import cvFR from "./../assets/cv.pdf";
import cvEN from "./../assets/cv-en.pdf";

const AccueilBody = () => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language.split("-")[0];
    const cvFile = lang === "en" ? cvEN : cvFR;

    return (
        <div>
            <div className="about-section marginTop2">
                <div className="about-container">
                    <div className='row'>
                        <div className="about-text col-lg-6 col-12 order-2 order-lg-1">
                            <h3 className="sousTitre">{t('about')}</h3>
                            <p>
                                <Trans i18nKey="about.intro" components={{ bold: <b /> }} />
                            </p>
                            <p>{t("about.para2")}</p>
                            <p className='mt-4'>
                                <a href={cvFile} target="_blank" className="buttonOutlined">{t('btn.cv2')}</a>
                            </p>
                        </div>

                        <div className="about-image col-lg-6 col-12 order-1 order-lg-2 ">
                            <div className="image-filter">
                                <img src={require("./../assets/portrait.jpg")} alt="portrait" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section second-section">
                <div className="about-container">
                    <div className="row">
                        <div className="about-image col-lg-6 col-12 ">
                            <div className="image-filter">
                                <img src={require("./../assets/diplome.jpg")} alt="portrait" />
                            </div>
                        </div>

                        <div className="about-text col-lg-6 col-12">
                            <h3 className='sousTitre'>
                                <Trans i18nKey="about.education" components={{ span: <span className="excellence" /> }} />
                            </h3>
                            <p className="pt-3">
                                <Trans
                                    i18nKey="about.education.para"
                                    components={{
                                        certificat: <span className="bleu"><b /></span>,
                                        bold: <b />
                                    }}
                                />
                            </p>
                        </div>
                    </div>
                </div>
                <div id="techno-section"></div>
            </div>
        </div>

    );
};

export default AccueilBody;
